<template>
  <PrimeBreadcrumb
    :home="home"
    :model="items"
    style="margin-top: 0px"
  ></PrimeBreadcrumb>

  <form @submit.prevent="save">
    <div class="p-fluid">
      <div class="p-field">
        <div class="row">
          <div class="col-3">
            <my-text-single
              v-model="my_item.custNo"
              :label="'客戶編號'"
              :required="true"
              :maxlength="10"
            ></my-text-single>
          </div>
          <div class="col-3">
            <my-text-single
              v-model="my_item.custName"
              :label="'客戶名稱'"
              :required="true"
              :maxlength="10"
            ></my-text-single>
          </div>

          <div class="col-5">
            <my-number-single
              v-model="rangenumber"
              :label="'預取數'"
              :min="0"
              :max="maxcount"
            ></my-number-single>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="rangenumber>0">
      <div class="col-8"></div>
      <div class="col-2">
        <PrimeButton
          label="Cancel"
          icon="pi pi-times"
          class="p-button-secondary"
          @click="closeModal()"
        />
      </div>
      <div class="col-2">
        <PrimeButton
          type="submit"
          label="Save"
          icon="pi pi-check"
          class="p-button-primary"
        />
      </div>
    </div>
  </form>
  目前可用號碼數量{{ maxcount }}<br />
  目前編號:{{ readyHCTNo }}<br />
</template>


<script>
import service from "../service/Appservice";

export default {
  props: ["item"],
  data() {
    return {
      my_item: {},

      home: { icon: "pi pi-home", to: "/" },
      items: [
        { label: "代理" },
        { label: "代理維護" },
        { label: "代理區間號" },
        { label: "代理區間號維護" },
        { label: "客戶預取號" },
        { label: "客戶預取號維護" },
      ],

      rangenumber: 0,
      maxcount: 0,
      readyHCTNo: [],
      lstHCTedelno_CustHaveUsed: [],
      lstHCTedelno_Avaliable: []
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    clientId() {
      return this.$store.state.user?.clientId;
    },
  },
  service: null,
  created() {
    var self = this;
    this.my_item = this.item;
   
    console.log("created................");
    console.log(this.my_item);
    console.log("created.................");
   this.service = new service();
    if(!this.my_item.pkey){ //新稱
        this.service.getAvaliableHCTedelno(this.item.parentpkey).then((data) => {
        self.lstHCTedelno_Avaliable = [...data];
        self.maxcount = self.lstHCTedelno_Avaliable.length;

      });
    } 
    else {//修改
      this.lstHCTedelno_CustHaveUsed= this.item.lstHCTedelno_CustHaveUsed;
      this.lstHCTedelno_Avaliable= this.item.lstHCTedelno_Avaliable;
      self.maxcount = self.lstHCTedelno_Avaliable.length;
      self.rangenumber = this.item.requestCount;

    }
  },
  watch: {
    // whenever question changes, this function will run
    rangenumber(newval, oldval) {
      console.log(oldval);
      if (newval && newval > 0) {
        if (newval > this.maxcount) {
          newval = this.maxcount;
        }
        console.log("watch rangenumber ..........");
        console.log("newval");
        console.log(newval);
        console.log("watch rangenumber ..........");
        this.readyHCTNo = this.lstHCTedelno_Avaliable.slice(0, newval);
      }
    },
  },

  methods: {
    open() {
      this.isShowDialog = true;
    },
    closeModal() {
      this.$emit("close");
    },
    save() {
      var self = this;
      self.my_item.createTime = new Date().toISOString();
      self.my_item.updateTime = new Date().toISOString();
      self.my_item.clientId = self.clientId;

      self.my_item.lstHCTedelno_CustRequest = self.readyHCTNo;
      self.my_item.requestCount= self.rangenumber;

      this.service
        .updateAgentCustHCTedelnoRange(this.my_item)
        .then((data) => {
          self.my_item = data;
          self.$emit("save", data);
          self.$emit("itemsavedone", self.my_item);
        })
        .catch((error) => {
          if (error.response) {
            alert(error.response.data.exceptionMessage);
            // 请求已发出，但服务器响应的状态码不在 2xx 范围内
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
          console.log(error.config);
        });
    },
  },
};
</script>